/**
 * Create/Copy Review Cycle wizard breadcrumb origin; mirrors `workflowsBreadcrumbs`. Falls back to
 * Review Cycles when `from` is absent — e.g. the Copy flow, which redirects in without one.
 */
import { type OriginMatcher, createOriginParser } from "./breadcrumbOrigin";
import { REVIEW_CYCLES_LIST_HREF } from "./reviewsBreadcrumbs";

export { appendCurrentLocationAsFrom } from "./breadcrumbOrigin";

const ORIGIN_MATCHERS: OriginMatcher[] = [
	{ match: "/company/reviews/cycles", label: "Review Cycles" },
	{ match: "/company/reviews/all", label: "Company Reviews" },
];

export const CREATE_REVIEW_CYCLE_DEFAULT_ORIGIN = { href: REVIEW_CYCLES_LIST_HREF, label: "Review Cycles" } as const;

export const parseCreateReviewCycleOrigin = createOriginParser(ORIGIN_MATCHERS, CREATE_REVIEW_CYCLE_DEFAULT_ORIGIN);
